export default __webpack_public_path__ + "static/media/copyRule.5fa2fff3.svg";